<form [formGroup]="transportForm" class="h-100">
    <div *ngIf="selectedCapacity$ | async" class="h-100 offset-xl-2 col-4 col-lg-3 selectedDateSection p-2 pt-0">
        <div class="d-flex px-4 mt-2">
            <span class="capHeader">{{(selectedCapacity$ | async)?.date | date: 'dd, MMMM, yyyy'}}</span>
            <span class="capHeaderIcon ml-2 px-1 my-auto">
                <span [ngClass]="(selectedCapacity$ | async)?.slot?.healthInd + 'Capacity'"
                    class="statusSpan d-inline-flex"></span>
                <ng-container [ngSwitch]="(selectedCapacity$ | async)?.slot?.healthInd">
                    <ng-container *ngSwitchCase="CapacityHealthIndEnum.FULL">
                        {{capacityHeathDisplayEnum.FULL}}
                    </ng-container>
                    <ng-container *ngSwitchCase="CapacityHealthIndEnum.HALF">
                        {{capacityHeathDisplayEnum.HALF}}
                    </ng-container>
                    <ng-container *ngSwitchCase="CapacityHealthIndEnum.LOW">
                        {{capacityHeathDisplayEnum.LOW}}
                    </ng-container>
                </ng-container>
            </span>
        </div>
        <mat-divider class="my-3 mx-4"></mat-divider>
        <div class="d-flex px-4 flex-column">
            <span class="availability-title mb-2">Today's Availability</span>
            <div class="d-flex flex-row mb-1">
                <span class="availability-label">Booked Hours</span>
                <span class="availability-value">{{(selectedCapacity$ | async)?.hour?.booked}}</span>
            </div>
            <div class="d-flex flex-row mb-1">
                <span class="availability-label">Remaining Hours</span>
                <span class="availability-value">{{(selectedCapacity$ | async)?.hour?.remaining}}</span>
            </div>
            <div class="d-flex flex-row mb-1">
                <span class="availability-label">Booked Slots</span>
                <span class="availability-value">{{(selectedCapacity$ | async)?.slot?.booked}}</span>
            </div>
            <div class="d-flex flex-row mb-1">
                <span class="availability-label">Remaining Slots</span>
                <span class="availability-value">{{(selectedCapacity$ | async)?.slot?.remaining}}</span>
            </div>
        </div>
        <mat-divider class="my-3 mx-4"></mat-divider>
        <div class="d-flex px-4 mb-4 flex-column">
            <span class="availability-title mb-2">Transportation Available</span>
            <div formArrayName="transportOptions" class="d-flex no-gutters flex-wrap transport-checkboxes">
                <div *ngFor="let transport of transportOptionsArr.controls; let i = index" class="col-4">
                    <mat-checkbox [formControlName]="i" [value]="transportOptions[i]">{{transportOptions[i].name}}
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <div class="d-flex mb-3 action-size">
            <div class="col-6 text-center">
                <button mat-stroked-button class="w-100 asp-btn-secondary" (click)="editCapacity()">Edit Shop Max
                    Slots</button>
            </div>
            <div class="col-6 text-center">
                <button mat-stroked-button class="w-100 asp-btn-secondary">Edit Shop Max Hours</button>
            </div>
        </div>
        <div class="flex mb-2 action-size">
            <div class="col-12 text-center">
                <button mat-stroked-button class="w-100 asp-btn-primary">Save</button>
            </div>
        </div>
        <div class="flex action-size">
            <div class="col-12 text-center">
                <button mat-button class="w-100 asp-btn-secondary">Reset Capacity Override</button>
            </div>
        </div>
    </div>
</form>